import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import WOW from "wowjs";
import { useGetTeamsQuery } from "../../store/api";
import { Spinner } from "react-bootstrap";
import { useTeamSheet } from "../../hooks/sheet.hook";

const TeamComponent = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const team_sheet = useTeamSheet();

  useEffect(() => {
    // Initialize WOW.js
    new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 100,
      mobile: true,
      live: true,
    }).init();
  }, []);
  //511 × 448
  //350 × 280
  return (
    <section className="team-one" id="management-team">
      <div className="container">
        <div className="section-title text-center">
          <span className="section-title__tagline">Expert Team</span>
          <h2 className="section-title__title">Meet Our Management Team.</h2>
        </div>
        {team_sheet.isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "24px",
            }}
          >
            <Spinner />
          </div>
        )}

        <div className="row">
          {(team_sheet.data || []).map((member, index) => (
            <div
              className={`col-xl-12 col-lg-12 wow fadeIn${
                index % 2 === 0 ? "Left" : "Right"
              }`}
              data-wow-delay={member.delay}
              key={member.name}
              id={`management-team-${member.id}`}
            >
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-12">
                  <div
                    className="team-one__single"
                    style={{ width: "350px", maxWidth: "100%" }}
                  >
                    <Link
                      to={`${process.env.PUBLIC_URL}/about/#management-team-${member.id}`}
                    >
                      <div
                        className="team-one__img"
                        style={{
                          background: "#ebebeb",
                        }}
                      >
                        <img
                          src={`${member.image}`}
                          alt={member.name}
                          style={{
                            height: "300px",
                          }}
                        />
                      </div>
                    </Link>
                    <div className="team-one__content">
                      <h4 className="team-one__name">
                        <Link
                          to={`${process.env.PUBLIC_URL}/about/#management-team-${member.id}`}
                        >
                          {member.name}
                        </Link>
                      </h4>
                      <p className="team-one__title">{member.title}</p>
                      <div className="team-one__social d-none">
                        <a href={member.twitter}>
                          <i className="fab fa-twitter"></i>
                        </a>
                        <a href={member.facebook}>
                          <i className="fab fa-facebook"></i>
                        </a>
                        <a href={member.instagram}>
                          <i className="fab fa-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-8 col-md-12 team-full-bio">
                  {member.bio}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamComponent;
